import CustomIconButton from "components/CustomIconButton";
import Dialog from "./Dialog";
import { useEffect, useState } from "react";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import usePwa from "hooks/usePwa";
import { isAppleDevice } from "config/functions";
import useElectron from "hooks/useElectron";
import useLogOut from "hooks/useLogOut";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PLUGIN_NAME } from "config/const";
import {
    Avatar,
    Badge,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {
    ContactsOutlined,
    GetAppOutlined,
    LogoutOutlined,
    NotificationsActiveOutlined,
    Person
} from "@mui/icons-material";


const Profile = ({ user }) => {
    const theme = useTheme()
    const navigate = useNavigate();
    const { isElectron } = useElectron()
    const { logOut } = useLogOut();
    const { bt } = useBizTypeTranslation();
    const { installApp, showInstallButton, checkPWA } = usePwa();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const notifications = useSelector((state) => state.notification?.list);
    const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);
    const [openProfile, setOpenProfile] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [notificationsLength, setNotificationsLength] = useState(0);

    useEffect(() => {
        if (selectedPlugin !== PLUGIN_NAME.MICRO_CONTROLLERS)
            setNotificationsLength(notifications?.filter(i => !i?.mc && !i?.readBy?.some(r => r?.employee?._id === user?.id))?.length || 0)
        else
            setNotificationsLength(notifications?.filter(i => !i?.readBy?.some(r => r?.employee?._id === user?.id))?.length || 0);
    }, [selectedPlugin, notifications]);

    const menuOptions = [
        {
            title: "PROFILE",
            icon: <ContactsOutlined />,
            show: true,
            onClick: () => setOpenProfile(true),
        },
        {
            title: "NOTIFICATION",
            icon: <NotificationsActiveOutlined />,
            show: true,
            Badge: notificationsLength,
            onClick: () => navigate("/Notification"),
        },
        { title: "Divider", show: true },
        {
            title: "INSTALL_APP",
            icon: <GetAppOutlined sx={{ color: "success.main" }} />,
            show: !isAppleDevice() && showInstallButton && !checkPWA() && !isElectron(),
            titleColor: "success.main",
            onClick: () => installApp(),
        },
        {
            title: "LOGOUT",
            icon: <LogoutOutlined sx={{ color: "error.text" }} />,
            show: true,
            titleColor: "error.text",
            onClick: () => logOut(),
        },
    ];

    const onClickMenuItem = (item) => {
        item?.onClick()
        setOpenMenu(null)
    }

    return (
        <>
            {isMobile
                ? <Badge
                    badgeContent={notificationsLength}
                    color="primary"
                    onClick={(event) => setOpenMenu(event.currentTarget)}
                    sx={{
                        '& .MuiBadge-badge': {
                            right: 30,
                            top: 7,
                            border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
                            width: 24,
                            height: 20,
                            fontSize: 10,
                        },
                    }}
                >
                    <IconButton onClick={(event) => setOpenMenu(event.currentTarget)}>
                        <Person color="secondary" />
                    </IconButton>
                </Badge>
                : <CustomIconButton
                    icon={
                        <Badge
                            badgeContent={notificationsLength}
                            color="secondary"
                            sx={{
                                '& .MuiBadge-badge': {
                                    right: 40,
                                    top: 3,
                                    border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
                                },
                            }}
                        >
                            <Avatar
                                onClick={(event) => setOpenMenu(event.currentTarget)}
                                sx={{ width: 40, height: 40, pb: 0.3, bgcolor: "primary.main" }}
                            >
                                <Typography fontSize={14} color="bg.main">
                                    {`${user?.fn[0]} ${user?.ln[0]}`}
                                </Typography>
                            </Avatar>
                        </Badge>
                    }
                    hideBgcolor
                />
            }

            <Menu
                MenuListProps={{ "aria-labelledby": "long-button" }}
                anchorEl={openMenu}
                open={openMenu ? true : false}
                onClose={() => setOpenMenu(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                {menuOptions?.map((btn, idx) => {
                    return (
                        btn?.title === "Divider"
                            ? <Divider />
                            : <MenuItem key={idx} onClick={() => onClickMenuItem(btn)}>
                                <Badge
                                    badgeContent={btn?.Badge ? btn?.Badge : 0}
                                    color="primary"
                                    variant="dot"
                                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                >
                                    <Stack direction="row" spacing={1}>
                                        {btn?.icon}
                                        <Typography color={btn?.titleColor}>{bt(btn?.title)}</Typography>
                                    </Stack>
                                </Badge>
                            </MenuItem>
                    )
                })}
            </Menu>

            {openProfile ? <Dialog open={openProfile} setOpen={setOpenProfile} /> : null}
        </>
    );
};

export default Profile;